import styled from 'styled-components';
import {textCss} from '../../styles/text.styled';
import {boxCss} from '../../styles/box.styled';
import {alignCss} from '../../styles/align.styled';
import {backgroundCss} from '../../styles/background.styled';

export const Content = styled.div`
  margin: 0;
  ${alignCss};
  ${backgroundCss};
  ${boxCss};
  ${textCss};
`;

